/*
 * @Author: FengXiao
 * @Date: 2020-07-01 22:19:22
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-03 21:56:36
 */
import Cookies from 'js-cookie';
import axios from 'axios';
import { Message } from 'element-ui';
const SUCCESS_COODES = ['0', 0, '200', 200];
const httpConfig = {
  timeout: 30000,
  // baseURL: process.env.VUE_APP_URL,
};
const service = axios.create(httpConfig);

// 因为无效用户没有对应的error_code 只能用愚蠢的汉字判断法……fml
const noLoginMsg = ['登录的User不存在', '用户没登录'];
service.interceptors.request.use(
  config => {
	  config.headers['authcode'] = '$yf&cpup8d%@s2h%'
    // 去get缓存hack
    if (config.method === 'get') {
      config.params = { ...config.params, ...{ _: new Date().getTime() } };
    }
    if (Cookies.get('token')) {
      config.headers = { ...config.headers, Authorization: `Bearer ${Cookies.get('token')}` };
    }
    return config;
  },
  error => Promise.reject(error)
);
service.interceptors.response.use(
  res => {
    if (noLoginMsg.includes(res.data.error_msg)) {
      window.$store.commit('setUser', null);
      window.$store.commit('setToken', '');
      window.$router.push('/login');
      return;
    }
    if (SUCCESS_COODES.includes(res.data.error_code)) {
      return res.data.data;
    }
    if (res.config.printMsg) {
      Message.error(res.data.error_msg);
    }
    return Promise.reject(res.data);
  },
  error => Promise.reject(error)
);

export default service;
